import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useLocation from 'hooks/useLocation';
import { getCardLoggersById } from 'libs/common/braze/utils/event-loggers';
import { getUserExternalId, getUserId } from 'state/session/selectors';
import { logBrazeMessage } from 'libs/common/braze/utils/error-loggers';
import { flushCustomEventsThrottled } from 'libs/common/braze/utils/custom-event';
import { requestContentCardsRefreshThrottled } from 'libs/common/braze/utils/async-utils';
import useInitializeBraze from './useInitializeBraze';
import BrazeContext, { initialBrazeContextValue } from './BrazeContext';
import useManageInAppMessage from './useManageInAppMessage';
import { jsx as _jsx } from "react/jsx-runtime";

const BrazeProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: providers,
    1: setProviders
  } = useState();
  const {
    0: contextValue,
    1: setContextValue
  } = useState(initialBrazeContextValue);
  const {
    0: isInitialized,
    1: setIsInitialized
  } = useState(false);
  const {
    relativeUrl
  } = useLocation();
  const userExternalId = useSelector(getUserExternalId);
  const userId = useSelector(getUserId);
  const initializeBraze = useInitializeBraze();
  useManageInAppMessage(providers === null || providers === void 0 ? void 0 : providers.inAppMessageProvider);
  useEffect(() => {
    initializeBraze().then(_ref2 => {
      let {
        initialized,
        stores,
        providers: newProviders
      } = _ref2;
      const cardStores = [stores.inboxMessageCardStore, stores.inboxNotificationCardStore, stores.promoBoxCardStore];
      const cardLoggers = getCardLoggersById(cardStores);
      if (newProviders) setProviders(newProviders);
      setIsInitialized(initialized);
      setContextValue(prevContextValue => _objectSpread(_objectSpread(_objectSpread({}, prevContextValue), stores), cardLoggers));
    });
  }, [initializeBraze]);
  const handleRelativeUrlChange = useCallback(() => {
    if (!userId || !userExternalId) return;
    if (!isInitialized) return;

    try {
      flushCustomEventsThrottled(userExternalId, userId);
      requestContentCardsRefreshThrottled();
    } catch (error) {
      if (error instanceof Error) {
        logBrazeMessage("errorHandlingNewPage(".concat(error.message, ")"));
      }
    }
  }, [isInitialized, userId, userExternalId]);
  useEffect(() => {
    handleRelativeUrlChange();
  }, [relativeUrl, handleRelativeUrlChange]);
  return /*#__PURE__*/_jsx(BrazeContext.Provider, {
    value: contextValue,
    children: children
  });
};

export default BrazeProvider;